import {
  RoleActions,
  GET_KNOWN_ROLES,
  GET_MY_ROLES,
  GET_ROLE_BUNDLES,
  GET_ROLE_BUNDLE_MAPPINGS,
  GET_SKILL_DATA,
} from "../../types/actions/Role.actions";
import { KnownLocation } from "../../types/models/KnownLocation";
import { KnownRole } from "../../types/models/KnownRole";
import { RoleState } from "../../types/models/RoleState";

const initialSettings: RoleState = {
  knownRoles: undefined,
  myRoles: undefined,
  myLocations: undefined,
  contentAuthor: undefined,
  onboarded: undefined,
  roleBundles: undefined,
  roleBundleMappings: undefined,
  skillList: undefined,
};

const RoleReducer = (state = initialSettings, action: RoleActions) => {
  const roles: { roles: KnownRole[]; locations: KnownLocation[] } = {
    roles: [],
    locations: [],
  };

  switch (action.type) {
    case GET_KNOWN_ROLES:
      roles.roles = action.payload?.roles ?? [];
      roles.locations = action.payload?.locations.map((location) => location) ?? [];

      return {
        ...state,
        knownRoles: roles,
      };
    case GET_MY_ROLES:
      return {
        ...state,
        myRoles: action.payload?.roles,
        myLocations: action.payload?.locations,
        contentAuthor: action.payload?.contentAuthor,
        onboarded: action.payload?.onboarded,
      };
    case GET_ROLE_BUNDLES:
      return {
        ...state,
        roleBundles: action.payload,
      };
    case GET_ROLE_BUNDLE_MAPPINGS:
      return {
        ...state,
        roleBundleMappings: action.payload,
      };
    case GET_SKILL_DATA:
      return {
        ...state,
        skillList: action.payload,
      };
    default:
      return state;
  }
};

export default RoleReducer;
